import { render, staticRenderFns } from "./MtrlEditMain.vue?vue&type=template&id=6fffef18&scoped=true&"
import script from "./MtrlEditMain.vue?vue&type=script&lang=js&"
export * from "./MtrlEditMain.vue?vue&type=script&lang=js&"
import style0 from "./MtrlEditMain.vue?vue&type=style&index=0&id=6fffef18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fffef18",
  null
  
)

export default component.exports